import {Button, Stack} from "@mui/material";
import {Link as RouterLink} from "react-router";
import React from "react";
import {PATH} from "../../routing/routes";
import LanguageHandler from "../../translations/LanguageHandler";

const DesktopMenu = () => {
    return (
        <Stack direction="row" width="100%" spacing={1} alignItems="end">
            <Button to={PATH.HOME} component={RouterLink}>
                {LanguageHandler.getTranslatedText("ABOUT_US")}
            </Button>
            <Button to={PATH.SERVICES} component={RouterLink}>
                {LanguageHandler.getTranslatedText("SERVICES")}
            </Button>
            <Button to={PATH.CONTACT} component={RouterLink}>
                {LanguageHandler.getTranslatedText("CONTACT")}
            </Button>
        </Stack>
    );
};

export default DesktopMenu;